import {
  createSchoolClassAsync,
  deleteSchoolClassAsync,
  getAllSchoolClassByLicenseAsync,
  getSchoolClassByIdAsync,
  updateSchoolClassAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSchoolClassAsync = () =>
  useMutation(createSchoolClassAsync);

export const useGetSchoolClassByIdAsync = () =>
  useMutation(getSchoolClassByIdAsync);

export const useGetAllSchoolClassByLicenseAsync = () =>
  useMutation(getAllSchoolClassByLicenseAsync);

export const useUpdateSchoolClassAsync = () =>
  useMutation(updateSchoolClassAsync);

export const useDeleteSchoolClassAsync = () =>
  useMutation(deleteSchoolClassAsync);
